import { render, staticRenderFns } from "./ChartsBlock.vue?vue&type=template&id=5d085ec1"
import script from "./ChartsBlock.vue?vue&type=script&lang=js"
export * from "./ChartsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports